import { render, staticRenderFns } from "./handbook.vue?vue&type=template&id=512b1e4c&scoped=true&"
import script from "./handbook.vue?vue&type=script&lang=js&"
export * from "./handbook.vue?vue&type=script&lang=js&"
import style0 from "./handbook.vue?vue&type=style&index=0&id=512b1e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b1e4c",
  null
  
)

export default component.exports